import { useTranslation } from 'react-i18next';
import Select from 'react-select';
import { FormTaxonomy } from '@/components/custom/form';

const RequirementStep = props => {
  const { t } = useTranslation();
  const { values, modules, setFieldValue, isOpenModalTaxonomies, setIsOpenModalTaxonomies, currentModule, setRemovedItems, removedItems, isLoadingTaxonomies, errors, touched, taxonomies } = props;

  return (
    <div className="page__content mb-12 animate-fade-in">
      <div className="new-questions__header">
        <h2 className="new-questions__title">{values?.title}</h2>
      </div>

      <fieldset className="form__row">
        <legend className="form__label">{t('lms.requirements')}</legend>

        <Select
          openMenuOnFocus
          value={values.selectedRequirements}
          onChange={selected => {
            const removed = values.selectedRequirements.filter(item => !selected.includes(item));
            setRemovedItems([...removedItems, ...removed]);
            setFieldValue('selectedRequirements', selected);
          }}
          isMulti
          options={modules
            .map(
              e =>
                currentModule?.id !== e.id && {
                  label: e.title,
                  value: e.id
                }
            )
            .filter(e => e)}
          className="react-multi-select"
          classNamePrefix="react-multi-select"
          placeholder={t('lms.placeholderSelectRequirements')}
          noOptionsMessage={() => 'Sem opções'}
          components={{
            IndicatorSeparator: () => null,
            ClearIndicator: () => null
          }}
        />
      </fieldset>

      <FormTaxonomy
        label={t('tasks.mattersRelated')}
        isLoading={isLoadingTaxonomies}
        taxonomies={taxonomies}
        selectedTaxonomies={values?.selectedTaxonomies}
        setFieldValue={setFieldValue}
        errors={errors}
        touched={touched}
        isOpenModalTaxonomies={isOpenModalTaxonomies}
        setIsOpenModalTaxonomies={setIsOpenModalTaxonomies}
      />

      {/* <fieldset className="form__row">
    <legend className="form__label">
      Imagem (1050 x 360 pixels)
    </legend>

    <label className="form__custom-file-input">
      <input
        type="file"
        name="image"
        id="image"
        accept=".jpeg, .png, .jpg"
        onChange={handleChangeImage}
        defaultValue={values.image}
      />
      <span className="form__control">
        {imageLabel
          ? imageLabel
          : 'Clique para fazer upload de uma imagem'}
      </span>
    </label>
  </fieldset> */}
    </div>
  );
};

export default RequirementStep;
